























































































































import {
  computed, defineComponent, reactive, ref, Ref,
} from '@vue/composition-api';
import _ from 'lodash';
import { useRouter, useFormat } from '@ideavivat/vivat-2';
import PrettyCheck from 'pretty-checkbox-vue/check';

import useDelivery from '@/useDelivery';

import useDownloadReport from '@/useDownloadReport';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useAuth from '@/useAuth';
import deliveriesTableOption from '@/table/report/csv/deliveries';
import {
  NOW_START_MONTH,
  NOW_END_MONTH,
} from '@/utils';

import CommonDeliveryStatusSelect from '@/components/Delivery/CommonDeliveryStatusSelect.vue';

import getHubs from '@/gql/company/getHubs.gql';
import getNecessaryDeliveries from '@/gql/report/csv/getNecessaryDeliveries.gql';
import getDeliveryNotesForSelector from '@/gql/deliveryNote/getDeliveryNotesForSelector.gql';

const NOW = useFormat.date().computerShortDate();

const RawDeliveriesCSV = defineComponent({
  components: {
    PrettyCheck,
    CommonDeliveryStatusSelect,
  },
  setup() {
    const { me } = useAuth();
    const { router } = useRouter();
    const { getRawDataReport } = useDownloadReport();
    const { translateDistanceType, distanceTypeToChipClass } = useDeliveryAreaCode();
    const { type, typeDisplay } = useDelivery();

    const filter = reactive({
      status: '',
      orderNumber: '',
      customerName: '',
      hub: undefined,
      destinationHub: undefined,
      hasDeliveryNote: undefined,
      deliveryNote: undefined,
      range: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
      orderDate: {
        from: undefined,
        to: undefined,
      },
      type: undefined,
    });

    const allowedToExport = computed(() => filter.status || filter.orderNumber
      || filter.customerName || filter.hub
      || filter.destinationHub
      || filter.hasDeliveryNote
      || filter.deliveryNote
      || filter.range.from || filter.range.to
      || filter.orderDate.from || filter.orderDate.to || filter.type);

    function clearFilter() {
      filter.status = '';
      filter.orderNumber = '';
      filter.customerName = '';
      filter.hub = undefined;
      filter.destinationHub = undefined;
      filter.hasDeliveryNote = undefined;
      filter.deliveryNote = undefined;
      // filter.range.from = undefined;
      filter.range.to = undefined;
      filter.orderDate.from = undefined;
      filter.orderDate.to = undefined;
      filter.type = undefined;
    }

    const computedDateInput = computed(() => ({
      from: filter.orderDate.from ? `${filter.orderDate.from} 00:00:00` : undefined,
      to: filter.orderDate.from ? `${filter.orderDate.to} 23:59:59` : undefined,
    }));

    const computedCreatedDateInput = computed(() => ({
      from: filter.range.from ? `${filter.range.from} 00:00:00` : undefined,
      to: filter.range.from ? `${filter.range.to} 23:59:59` : undefined,
    }));

    const ordersVariable = computed(() => {
      const vars: {[key: string]: any} = {
        /* eslint-disable */
        status: undefined,
        created_since: undefined,
        created_before: undefined,
        ordered_since: undefined,
        ordered_before: undefined,
        hub_id: undefined,
        destination_hub_id: undefined,
        has_dn: undefined,
        customer_name: undefined,
        order_number: undefined,
        type: undefined,
        // filter: undefined,
        filterDeliveryNoteId: undefined,
      };
      if (filter.orderNumber) vars.order_number = `%${filter.orderNumber}%`;
      if (filter.customerName) vars.customer_name = `%${filter.customerName}%`;
      if (filter.status) vars.status = filter.status;
      if (filter.orderDate.from) {
        vars.ordered_since = computedDateInput.value.from;
        vars.created_before = computedDateInput.value.to;
      }
      if (filter.range.from) {
        vars.created_since = computedCreatedDateInput.value.from;
        vars.created_before = computedCreatedDateInput.value.to;
      }
      if (me.hub.hubType !== 'MAIN' || filter.hub) vars.hub_id = (filter.hub as any)?.id || me.hubId;
      if (filter.destinationHub) vars.destination_hub_id = (filter.destinationHub as any)?.id || undefined;
      if (filter.hasDeliveryNote !== undefined && filter.hasDeliveryNote !== null) vars.has_dn = filter.hasDeliveryNote;

      if (filter.deliveryNote && filter.hasDeliveryNote) vars.filterDeliveryNoteId = parseInt((filter.deliveryNote as any)?.id, 10) || undefined;
      if (filter.type) vars.type = filter.type;
      /* eslint-enable */
      return vars;
    });

    const getOrdersResult = (data: any) => data.deliveries;

    const selectedItemId: Ref<number[]> = ref([]);
    function selectItem(id: number | string) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(parseInt(id as string, 10));
    }

    const totalItems = ref(0);
    function handlerFetchData(queryData: any) {
      totalItems.value = queryData.total;
    }
    function handleSelectAllItem($event: any[]) { selectedItemId.value = $event; }
    const selectedAll = computed(() => selectedItemId.value.length === totalItems.value);

    function clickRowHandler(row: any) {
      router.push({ name: 'DeliveryInformation', params: { id: row.item.id } });
    }

    return {
      me,
      type,
      typeDisplay,
      clickRowHandler,
      getRawDataReport,
      translateDistanceType,
      distanceTypeToChipClass,

      clearFilter,
      filter,
      ordersVariable,
      getOrdersResult,
      selectedItemId,
      selectItem,

      getHubs,
      getNecessaryDeliveries,
      deliveriesTableOption,

      handlerFetchData,
      handleSelectAllItem,
      selectedAll,

      getDeliveryNotesForSelector,
      allowedToExport,
    };
  },
});

export default RawDeliveriesCSV;
